<ng-container>
  <div class="preview-container">
    @if (isPreviewTitle) {
      <div class="px-4 pt-4">
        <h1> {{previewTitle}} </h1>
      </div>
    }
    @if (isNotLastOrActive) {
      <hr class="m-4">
    }
    <div class="disclaimer px-4">
      @if ((isAuthReport || isAuthorizationEnabled) && !isSellerInvoice) {
        <p class="pe-2">
          {{altTranslations.disclaimer}}
        </p>
      }
    </div>
    <div class="container m-4">
      <div class="row">
        <div class="col-md-8 p-4">
          <h2>{{vehicleDisplayName}} @if (isAuthReport) {
            <span>{{vehicleDrivetrainEngineSize}}</span>
          }</h2>
          <div class="vin-stock d-flex">
            <h3>{{purchasedItem.itemDetail.vin}}</h3>
            @if (isStockNumberEnabled) {
              <h5>{{purchasedItem.itemDetail.stockNumber}} </h5>
            }
          </div>
          <div class="attributes">
            @if (!isRecordOfSaleMobile) {
              <div class="row py-3">
                <div class="attributes-content col-md-4">
                  <div class="attributes-content-row-1">
                    @if (isAuthReport) {
                      <app-datalist-item
                        [identifier]="'Seller'"
                        [label]="translatedObj.labelSeller"
                        value="{{purchasedItem.seller.name}}"
                      ></app-datalist-item>
                    }
                    @if (!isAuthReport) {
                      <app-datalist-item
                        [identifier]="'Seller'"
                        [label]="translatedObj.labelSeller"
                      ></app-datalist-item>
                      <span>{{purchasedItem.seller.name}}</span> <br>
                      <span>{{sellerAddressOne}}</span> <br>
                      <span>{{sellerCityState}}</span> <br>
                      <span>{{sellerZipCode}}</span> <br>
                    }
                    <app-datalist-item
                      [identifier]="'Seller Contact'"
                      [label]="translatedObj.labelSellerContact"
                      value="{{purchasedItem.seller.contactName}}"
                    ></app-datalist-item>
                    <app-datalist-item
                      [identifier]="'Seller Phone'"
                      [label]="translatedObj.labelSellerPhone"
                      value="{{purchasedItem.seller.contactPhone | formatPhoneNumber}}"
                    ></app-datalist-item>
                    @if (!!purchasedItem.seller.alternateContactName) {
                      <app-datalist-item
                        [identifier]="'Alternate Seller Contact'"
                        [label]="translatedObj.labelAltSellerContact"
                        value="{{purchasedItem.seller.alternateContactName}}"
                      ></app-datalist-item>
                    }
                    @if (!!purchasedItem.seller.alternateContactPhone) {
                      <app-datalist-item
                        [identifier]="'Alternate Seller Phone'"
                        [label]="translatedObj.labelAltSellerPhone"
                        value="{{purchasedItem.seller.alternateContactPhone | formatPhoneNumber}}"
                      ></app-datalist-item>
                    }
                  </div>
                  <div class="attributes-content-row-2">
                    @if (isAuthReportMobile) {
                      <app-datalist-item
                        class="sale-date"
                        [identifier]="'Sale Date'"
                        [label]="translatedObj.labelSaleDate"
                        value="{{localizeDate(purchasedItem.saleDate)}}"
                      ></app-datalist-item>
                      <app-datalist-item
                        [identifier]="'Body Type'"
                        [label]="translatedObj.labelBodyType"
                        value="{{purchasedItem.itemDetail.bodyType}}"
                      ></app-datalist-item>
                      <app-datalist-item
                        [identifier]="'Odometer'"
                        [label]="translatedObj.labelOdometer"
                        value="{{purchasedItem.itemDetail.odometer | number}} {{this.altTranslations.distanceUnits}}"
                      ></app-datalist-item>
                      <app-datalist-item
                        [identifier]="'Color'"
                        [label]="translatedObj.labelColor"
                        value="{{purchasedItem.itemDetail.color}}"
                      ></app-datalist-item>
                    }
                    @if (isTenantCanadian && !isAuthReport) {
                      <app-datalist-item
                        [identifier]="'Seller License'"
                        [label]="translatedObj.labelSellerLicenseNumber"
                        value="{{sellerLicenseNumber}}"
                      ></app-datalist-item>
                    }
                    @if (isTenantCanadian && !isAuthReport) {
                      <app-datalist-item
                        [identifier]="'Seller Federal'"
                        [label]="translatedObj.labelSellerFederalNumber"
                        value="{{sellerFederalNumber}}"
                      ></app-datalist-item>
                    }
                    @if (isTenantCanadian && purchasedItem.seller.quebecRegistrationId && !isAuthReport) {
                      <app-datalist-item
                        [identifier]="'Seller Quebec Reg'"
                        [label]="translatedObj.labelQuebecRegistration"
                        value="{{purchasedItem.seller.quebecRegistrationId }}"
                      ></app-datalist-item>
                    }
                    @if (!isAuthReport) {
                      <div class="storage-details-content">
                        <div class="storage-details-content-row-1">
                          <app-datalist-item
                            [identifier]="'Body Type'"
                            [label]="translatedObj.labelBodyType"
                            value="{{purchasedItem.itemDetail.bodyType}}"
                          ></app-datalist-item>
                          <app-datalist-item
                            [identifier]="'Odometer'"
                            [label]="translatedObj.labelOdometer"
                            value="{{purchasedItem.itemDetail.odometer | number}} {{this.altTranslations.distanceUnits}}"
                          ></app-datalist-item>
                        </div>
                        <div class="storage-details-content-row-2">
                          <app-datalist-item
                            [identifier]="'Color'"
                            [label]="translatedObj.labelColor"
                            value="{{purchasedItem.itemDetail.color}}"
                          ></app-datalist-item>
                          @if (isSellerPermitAndLicenseNumberEnabled) {
                            <app-datalist-item
                              [identifier]="'Seller Permit Number'"
                              [label]="translatedObj.labelSellerPermitNumber"
                              value="{{sellerPermitNumber}}"
                            ></app-datalist-item>
                          }
                          @if (isSellerPermitAndLicenseNumberEnabled) {
                            <app-datalist-item
                              [identifier]="'Seller Dealer License Number'"
                              [label]="translatedObj.labelSellerDealerLicenseNumber"
                              value="{{sellerLicenseNumber}}"
                            ></app-datalist-item>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
                @if (!isAuthReport) {
                  <hr class="mobile-hr d-block d-md-none my-2">
                }
                @if (!isAuthReportMobile) {
                  <div class="additional-content row col-md-8">
                    @if (isAuthReport) {
                      <div class="auth-report-content col-md-6">
                        <div class="auth-report-content-row-1">
                          <app-datalist-item
                            class="sale-date"
                            [identifier]="'Sale Date'"
                            [label]="translatedObj.labelSaleDate"
                            value="{{localizeDate(purchasedItem.saleDate)}}"
                          ></app-datalist-item>
                          <app-datalist-item
                            class="body-type"
                            [identifier]="'Body Type'"
                            [label]="translatedObj.labelBodyType"
                            value="{{purchasedItem.itemDetail.bodyType}}"
                          ></app-datalist-item>
                        </div>
                        <div class="auth-report-content-row-2">
                          <app-datalist-item
                            [identifier]="'Odometer'"
                            [label]="translatedObj.labelOdometer"
                            value="{{purchasedItem.itemDetail.odometer | number}} {{this.altTranslations.distanceUnits}}"
                          ></app-datalist-item>
                          <app-datalist-item
                            [identifier]="'Color'"
                            [label]="translatedObj.labelColor"
                            value="{{purchasedItem.itemDetail.color}}"
                          ></app-datalist-item>
                        </div>
                      </div>
                    } @else {
                      <div class="col-md-6 buyer-row">
                        <div class="buyer-details-content-row-1">
                          <app-datalist-item
                            [identifier]="'Buyer'"
                            [label]="translatedObj.labelBuyer"
                          ></app-datalist-item>
                          <span>{{buyerName}}</span>
                          <span>{{buyerAddressOne}}</span>
                          <span>{{buyerCityState}}</span>
                          <span>{{buyerZipCode}}</span>
                        </div>
                        <div class="buyer-details-content-row-2">
                          <app-datalist-item
                            [identifier]="'Buyer Phone'"
                            [label]="translatedObj.labelBuyerPhone"
                            value="{{buyerPhone}}"
                          ></app-datalist-item>
                          @if (isSellerPermitAndLicenseNumberEnabled) {
                            <app-datalist-item
                              [identifier]="'Buyer Permit Number'"
                              [label]="translatedObj.labelBuyerPermitNumber"
                              value="{{buyerPermitNumber}}"
                            ></app-datalist-item>
                          }
                          @if (isSellerPermitAndLicenseNumberEnabled) {
                            <app-datalist-item
                              [identifier]="'Buyer Dealer License Number'"
                              [label]="translatedObj.labelBuyerDealerLicenseNumber"
                              value="{{buyerLicenseNumber}}"
                            ></app-datalist-item>
                          }
                          @if (isTenantCanadian) {
                            <app-datalist-item
                              [identifier]="'Buyer License'"
                              [label]="translatedObj.labelBuyerLicenseNumber"
                              value="{{buyerLicenseNumber}}"
                            ></app-datalist-item>
                          }
                          @if (isTenantCanadian) {
                            <app-datalist-item
                              [identifier]="'Buyer Federal'"
                              [label]="translatedObj.labelBuyerFederalNumber"
                              value="{{buyerFederalNumber}}"
                            ></app-datalist-item>
                          }
                        </div>
                      </div>
                      <div class="col-md-6 record-of-sale-storage">
                        <ng-container *ngTemplateOutlet="storageLocation"></ng-container>
                      </div>
                    }
                  </div>
                }
                @if (isTenantCanadian) {
                  <span class="fw-bold condition-label ps-3">
                    {{translatedObj.labelDisclosures | uppercase}}:
                    @if (hasConditionIndicators) {
                      <ng-container class="d-flex flex-row condition-indicator">
                        <ng-content *ngTemplateOutlet="disclosures"></ng-content>
                      </ng-container>
                    } @else {
                      <p class="no-content">
                        N/A
                      </p>
                    }
                  </span>
                } @else {
                  <app-datalist-item  [label]="translatedObj.labelDisclosures" [identifier]="'vehicle_disclosures_text_'">
                    @if (hasConditionIndicators) {
                      <ng-container class="d-flex flex-row">
                        <ng-content *ngTemplateOutlet="disclosures"></ng-content>
                      </ng-container>
                    } @else {
                      <p class="no-content">
                        N/A
                      </p>
                    }
                  </app-datalist-item>
                }
              </div>
            } @else {
              <div class="row pt-3">
                <div class="seller-details attributes-content col-md-4">
                  <div class="mobile-content-row-1">
                    <app-datalist-item
                      class="mobile-label-spacing"
                      [identifier]="'Seller'"
                      [label]="translatedObj.labelSeller"
                    ></app-datalist-item>
                    <span>{{purchasedItem.seller.name}}</span> <br>
                    <span>{{sellerAddressOne}}</span> <br>
                    <span>{{sellerCityState}}</span> <br>
                    <span>{{sellerZipCode}}</span> <br>
                    <app-datalist-item
                      [identifier]="'Seller Contact'"
                      [label]="translatedObj.labelSellerContact"
                      value="{{purchasedItem.seller.contactName}}"
                    ></app-datalist-item>
                    <app-datalist-item
                      [identifier]="'Seller Phone'"
                      [label]="translatedObj.labelSellerPhone"
                      value="{{purchasedItem.seller.contactPhone | formatPhoneNumber}}"
                    ></app-datalist-item>
                    @if (!!purchasedItem.seller.alternateContactName) {
                      <app-datalist-item
                        [identifier]="'Alternate Seller Contact'"
                        [label]="translatedObj.labelAltSellerContact"
                        value="{{purchasedItem.seller.alternateContactName}}"
                      ></app-datalist-item>
                    }
                    @if (!!purchasedItem.seller.alternateContactPhone) {
                      <app-datalist-item
                        [identifier]="'Alternate Seller Phone'"
                        [label]="translatedObj.labelAltSellerPhone"
                        value="{{purchasedItem.seller.alternateContactPhone | formatPhoneNumber}}"
                      ></app-datalist-item>
                    }
                    @if (isSellerPermitAndLicenseNumberEnabled) {
                      <app-datalist-item
                        [identifier]="'Seller Permit Number'"
                        [label]="translatedObj.labelSellerPermitNumber"
                        value="{{sellerPermitNumber}}"
                      ></app-datalist-item>
                    }
                    @if (isSellerPermitAndLicenseNumberEnabled) {
                      <app-datalist-item
                        [identifier]="'Seller Dealer License Number'"
                        [label]="translatedObj.labelSellerDealerLicenseNumber"
                        value="{{sellerLicenseNumber}}"
                      ></app-datalist-item>
                    }
                  </div>
                  <div class="mobile-content-row-2">
                    @if (isTenantCanadian) {
                      <app-datalist-item
                        [identifier]="'Seller License'"
                        [label]="translatedObj.labelSellerLicenseNumber"
                        value="{{sellerLicenseNumber}}"
                      ></app-datalist-item>
                    }
                    @if (isTenantCanadian) {
                      <app-datalist-item
                        [identifier]="'Seller Federal'"
                        [label]="translatedObj.labelSellerFederalNumber"
                        value="{{sellerFederalNumber}}"
                      ></app-datalist-item>
                    }
                    @if (isTenantCanadian && purchasedItem.seller.quebecRegistrationId) {
                      <app-datalist-item
                        [identifier]="'Seller Quebec Reg'"
                        [label]="translatedObj.labelQuebecRegistration"
                        value="{{purchasedItem.seller.quebecRegistrationId }}"
                      ></app-datalist-item>
                    }
                  </div>
                </div>
                <hr class="mobile-hr d-block d-md-none my-2">
                <div class="buyer-details additional-content col-md-4">
                  <div class="mobile-content-row-1">
                    <app-datalist-item
                      class="mobile-label-spacing"
                      [identifier]="'Buyer'"
                      [label]="translatedObj.labelBuyer"
                    ></app-datalist-item>
                    <span>{{buyerName}}</span><br>
                    <span>{{buyerAddressOne}}</span><br>
                    <span>{{buyerCityState}}</span><br>
                    <span>{{buyerZipCode}}</span><br>
                    <app-datalist-item
                      [identifier]="'Buyer Phone'"
                      [label]="translatedObj.labelBuyerPhone"
                      value="{{buyerPhone}}"
                    ></app-datalist-item>
                    @if (isSellerPermitAndLicenseNumberEnabled) {
                      <app-datalist-item
                        [identifier]="'Buyer Permit Number'"
                        [label]="translatedObj.labelBuyerPermitNumber"
                        value="{{buyerPermitNumber}}"
                      ></app-datalist-item>
                    }
                    @if (isSellerPermitAndLicenseNumberEnabled) {
                      <app-datalist-item
                        [identifier]="'Buyer Dealer License Number'"
                        [label]="translatedObj.labelBuyerDealerLicenseNumber"
                        value="{{buyerLicenseNumber}}"
                      ></app-datalist-item>
                    }
                  </div>
                  <div class="mobile-content-row-1">
                    @if (isTenantCanadian) {
                      <app-datalist-item
                        [identifier]="'Buyer License'"
                        [label]="translatedObj.labelBuyerLicenseNumber"
                        value="{{buyerLicenseNumber}}"
                      ></app-datalist-item>
                    }
                    @if (isTenantCanadian) {
                      <app-datalist-item
                        [identifier]="'Buyer Federal'"
                        [label]="translatedObj.labelBuyerFederalNumber"
                        value="{{buyerFederalNumber}}"
                      ></app-datalist-item>
                    }
                  </div>
                </div>
                <hr class="mobile-hr d-block d-md-none my-2">
                <ng-container *ngTemplateOutlet="storageLocationContactMobile"></ng-container>
                <hr class="mobile-hr d-block d-md-none my-2">
                <div class="additional-content col-md-4">
                  <div class="mobile-content-row-1">
                    <app-datalist-item
                      [identifier]="'Body Type'"
                      [label]="translatedObj.labelBodyType"
                      value="{{purchasedItem.itemDetail.bodyType}}"
                    ></app-datalist-item>
                    <app-datalist-item
                      [identifier]="'Odometer'"
                      [label]="translatedObj.labelOdometer"
                      value="{{purchasedItem.itemDetail.odometer | number}} {{this.altTranslations.distanceUnits}}"
                    ></app-datalist-item>
                  </div>
                  <div class="mobile-content-row-2">
                    <app-datalist-item
                      [identifier]="'Color'"
                      [label]="translatedObj.labelColor"
                      value="{{purchasedItem.itemDetail.color}}"
                    ></app-datalist-item>
                  </div>
                  <div class="mobile-content-disclosures">
                    <app-datalist-item  [label]="translatedObj.labelDisclosures" [identifier]="'vehicle_disclosures_text_'">
                      @if (hasConditionIndicators) {
                        <ng-container class="d-flex flex-row">
                          <ng-content *ngTemplateOutlet="disclosures"></ng-content>
                        </ng-container>
                      } @else {
                        <p class="no-content">
                          N/A
                        </p>
                      }
                    </app-datalist-item>
                  </div>
                </div>
                <hr class="mobile-hr d-block d-md-none my-2">
                @if (isSellerInvoice) {
                  <ng-container *ngTemplateOutlet="reportSideSelectRemit"></ng-container>
                } @else {
                  <h2 class="pt-4 mb-4">{{translatedObj.textVehicleSummary}}</h2>
                  <div class="vehicle-summary-details additional-content col-md-4">
                    <div class="mobile-content-row-1">
                      <app-datalist-item
                        [identifier]="'Credit Line'"
                        [label]="translatedObj.labelCreditLine"
                        value="{{purchasedItem.financeSource.name}}"
                      ></app-datalist-item>
                      <app-datalist-item
                        [identifier]="'Sale Date'"
                        [label]="translatedObj.labelSaleDate"
                        value="{{localizeDate(purchasedItem.saleDate)}}"
                      ></app-datalist-item>
                      <app-datalist-item
                        [identifier]="'Sale Price'"
                        [label]="translatedObj.labelSalePrice"
                        value="{{formatCurrency(purchasedItem.salePrice, true)}}"
                      ></app-datalist-item>
                      <app-datalist-item
                        [identifier]="'Total Cost'"
                        [label]="translatedObj.labelTotalCost"
                        value="{{formatCurrency(totalCost, true)}}"
                      ></app-datalist-item>
                    </div>
                    <div class="mobile-content-row-2">
                      @for (fee of _buyFees | keyvalue: disableKeyValueSort; track fee) {
                        <div>
                          <app-datalist-item
                            [identifier]="fee.key"
                            [label]="fee.key"
                            value="{{formatCurrency(fee.value, true)}}"
                          ></app-datalist-item>
                        </div>
                      }
                    </div>
                  </div>
                }
                <hr class="mobile-hr d-block d-md-none my-2">
                <div class="additional-content col-md-4 && isRecordOfSaleMobile">
                  @if (isShowBuyerDetails) {
                    <div>
                      @if (isBuyerDetailEnabled) {
                        <p #note></p>
                      }
                    </div>
                  }
                  <!-- Mobile Record of Sale-->
                  <div class="mobile-content-row-1">
                    <ng-container>
                      <p>
                        <app-datalist-item
                          class="mobile-label-spacing"
                          [identifier]="'Auction'"
                          [label]="translatedObj.labelAuction"
                        ></app-datalist-item>
                        <span>{{tenantName}}</span><br>
                        <span>{{platformAddress}}</span>
                      </p>
                      @if (isTenantCanadian) {
                        <app-datalist-item
                          [identifier]="'Platform Provider'"
                          [label]="translatedObj.labelProvider"
                          value="{{platformProvider}}"
                        ></app-datalist-item>
                      }
                    </ng-container>
                  </div>
              @if(transportationCost) {
                <app-datalist-item
                  [identifier]="'Transportation Fee'"
                  [label]="translatedObj.labelTransportation">
                  {{formatCurrency(transportationCost)}} {{translatedObj.labelFrom}} {{transportationName}} <br>
                  <a href="mailto:{{transportationEmail}}">{{transportationEmail}}</a><br>
                  <a href="tel:{{transportationNumber | formatPhoneNumber}}">{{transportationNumber | formatPhoneNumber}}</a>
                </app-datalist-item>
                <p><span class="transportation-warning">{{translatedObj.transportationNotice}}</span>
                  {{translatedObj.transportationFeeNotice}}
                </p>
              }
            </div>
          </div>
        }
        <div class="preview-footer d-none d-md-block">
          @if (showSellerComment) {
            <app-datalist-item
              [identifier]="'Seller Comments'"
              [label]="translatedObj.labelSellerComments"
              value="{{purchasedItem.sellerPaidComment}}"
            ></app-datalist-item>
          }
          @if (showTitleMessage) {
            <app-datalist-item
              [identifier]="'Title Message'"
              [label]="translatedObj.labelTitleMessage"
              value="{{purchasedItem.financeSource.titleMessage}}"
            ></app-datalist-item>
          }
          @if (showSellerDisclosure) {
            <app-datalist-item
              [identifier]="'Seller Disclosure'"
              [label]="translatedObj.labelSellerDisclosure"
              value="{{purchasedItem.seller.comment}}"
            ></app-datalist-item>
          }
          @if (showStoringLocation) {
            <app-datalist-item
              [identifier]="'Storing Location Message'"
              [label]="translatedObj.labelStorage"
              value="{{purchasedItem.storageLocation.pickupComment}}"
            ></app-datalist-item>
            @if (purchasedItem.storageLocation.additionalPickupComment) {
              <div class="additional-pickup-comment">
                {{purchasedItem.storageLocation.additionalPickupComment}}
              </div>
            }
          }
        </div>

      </div>
    </div>
    @if (isAuthReport) {
      <hr class="mobile-hr d-block d-md-none mx-2">
    }
    @if (!isRecordOfSaleMobile) {
      <div class="side-section col-md-4">
        @if (isAuthReport) {
          @if (!isMobile) {
            <h4 class="p-4">{{translatedObj.labelStorageLocation}}</h4>
          }
          <ng-container *ngTemplateOutlet="storageLocation"></ng-container>
          <ng-container *ngTemplateOutlet="mobilePreviewFooter"></ng-container>
        } @else {
          @if (!isSellerInvoice) {
            <h4 class="p-4">{{translatedObj.textVehicleSummary}}</h4>
            <div class="vehicle-summary-content p-4">
              <div class="vehicle-summary-content-row-1">
                <app-datalist-item
                  [identifier]="'Credit Line'"
                  [label]="translatedObj.labelCreditLine"
                  value="{{purchasedItem.financeSource.name}}"
                ></app-datalist-item>
                <app-datalist-item
                  [identifier]="'Sale Date'"
                  [label]="translatedObj.labelSaleDate"
                  value="{{localizeDate(purchasedItem.saleDate)}}"
                ></app-datalist-item>
              </div>
              <div class="vehicle-summary-content-row-2">
                <app-datalist-item
                  [identifier]="'Sale Price'"
                  [label]="translatedObj.labelSalePrice"
                  value="{{formatCurrency(purchasedItem.salePrice, true)}}"
                ></app-datalist-item>
                @for (fee of _buyFees | keyvalue: disableKeyValueSort; track fee) {
                  <div>
                    <app-datalist-item
                      [identifier]="fee.key"
                      [label]="fee.key"
                      value="{{formatCurrency(fee.value, true)}}"
                    ></app-datalist-item>
                  </div>
                }
              </div>
            </div>
            <div class="totalAmount">
              <app-datalist-item
                [identifier]="'Total Cost'"
                [label]="translatedObj.labelTotalCost"
                value="{{formatCurrency(totalCost, true)}}"
              ></app-datalist-item>
            </div>
            @if (!isAuthReport) {
              <ng-container *ngTemplateOutlet="mobilePreviewFooter"></ng-container>
            }
          } @else {
            <h4 class="fw-bold vehicle-summary-header">{{translatedObj.textVehicleSummary}}</h4>
            <div class="vehicle-summary-remit-content">
              <div class="vehicle-summary-remit-content-row-1">
                <app-datalist-item
                  [identifier]="'Sale Date'"
                  [label]="translatedObj.labelSaleDate"
                  value="{{localizeDate(purchasedItem.saleDate)}}"
                ></app-datalist-item>
                <app-datalist-item
                  [identifier]="'Sale Price'"
                  [label]="translatedObj.labelSalePrice"
                  value="{{formatCurrency(purchasedItem.salePrice, true)}}"
                ></app-datalist-item>
              </div>
              <div class="vehicle-summary-remit-content-row-2">
                @if(!isSellSellerInvoiceReportVerbiageUpdateEnabled){
                <p class="fw-bold">{{translatedObj.textBuyerTaxes}}</p>
                <p>{{translatedObj.textBuyerTaxesSub}}</p>
                }
                @if (taxSource.proceedsFederalTax) {
                  <app-datalist-item
                  [identifier]="'Vehicle Price GST/HST'"
                  [label]="translatedObj.textPriceFederalTaxLabel"
                  [value]="formatCurrency(taxSource.proceedsFederalTax, true)"
                  ></app-datalist-item>
                }
                @if (taxSource.proceedsStateTax) {
                <app-datalist-item
                  [identifier]="'Vehicle Price PST/RST/QST'"
                  [label]="translatedObj.textPriceStateTaxLabel"
                  [value]="formatCurrency(taxSource.proceedsStateTax, true)"
                  ></app-datalist-item>
                }
              </div>
              <div class="vehicle-summary-remit-content-row-3">
                <p class="fw-bold">{{translatedObj.textSellerFeesAndTaxes}}</p>
                @for (fee of _sellFees | keyvalue: disableKeyValueSort; track fee) {
                  <div>
                    <app-datalist-item
                      [identifier]="fee.key"
                      [label]="translatedObj[fee.key]"
                      value="{{formatCurrency(fee.value, true)}}"
                    ></app-datalist-item>
                  </div>
                }
              </div>
            </div>
            <div class="total-amount-remit">
              <app-datalist-item
                [identifier]="'Total Cost'"
                [label]="translatedObj.labelNetProceeds"
                value="{{formatCurrency(totalCost, true)}}"
              ></app-datalist-item>
            </div>
          }
        }
      </div>
    }
  </div>
</div>
<div class="disclaimer px-4 pb-2">
  @if (isShowBuyerDetails && !isRecordOfSaleMobile && !isAuthReportMobile) {
    <div>
      @if (isBuyerDetailEnabled) {
        <p #note></p>
      }
    </div>
  }
  @if (isContactSupportEnabled) {
    <div class="d-flex gap-1">
      <p class="fw-bold">{{translatedObj.contactSupport}}</p>
      <p class="fw-bold text-decoration-underline">{{configuration.header.contactInfo.phoneNumber | formatPhoneNumber}}.</p>
    </div>
  }
  <p>
    @if (isDisclosureLinkEnabled && !isAuthReport) {
      <a routerLink="/summary-disclosures" rel="opener" target="_blank" class="view-disclosures"
        id="{{purchasedItem.inventoryItemUuid}}"
        (click)="setInventoryItemUuidIntoSession($event)">
        {{translatedObj.textviewdisclosures}}
      </a>
    }
  </p>
  <!-- Desktop -->
  @if (!isAuthReportMobile && !isRecordOfSaleMobile) {
    <ng-container>
      <app-datalist-item
        [identifier]="'Auction'"
        [label]="translatedObj.labelAuction"
        value="{{tenantName + '  ' + platformAddress}}"
      ></app-datalist-item>
      @if (transportationCost) {
        <app-datalist-item
          [identifier]="'Transportation Fee'"
          [label]="translatedObj.labelTransportation">
          {{formatCurrency(transportationCost)}} {{translatedObj.labelFrom}} {{transportationName}}
          · <a href="mailto:{{transportationEmail}}">{{transportationEmail}}</a>
          · {{transportationNumber | formatPhoneNumber}}
        </app-datalist-item>
      }
      @if (isTenantCanadian) {
        <app-datalist-item
          [identifier]="'Platform Provider'"
          [label]="translatedObj.labelProvider"
          value="{{platformProvider}}"
        ></app-datalist-item>
      }
    </ng-container>
        @if(transportationCost) {
          <p><span class="transportation-warning">{{translatedObj.transportationNotice}}</span>
          {{translatedObj.transportationFeeNotice}}
          <p>
        }
        @if (isTenantCanadian) {
          <div class="pt-3">
            <h2>{{translatedObj.termsOfUse.header}}</h2>
            <p #content></p>
          </div>
        }
        <br/>
        @if (hasDisclosures) {
          <h2 class="mt-1">
            {{translatedObj.labelDisclosures}}
          </h2>
        }
        @if (hasSellerDisclosureComment) {
          <p class="fw-bold">
            {{translatedObj.labelSellerDisclosures}}
          </p>
          <p>
            {{this.purchasedItem.conditionReport.sellerDisclosureComment}}
          </p>
        }
        @if (hasOdometerDisclosure) {
          <p class="fw-bold">
            {{translatedObj.labelOdometerDisclosure}}
          </p>
          <p>
            {{odometerDisclosure}}
          </p>
        }
        @if (hasDamages) {
          <p class="fw-bold">
            {{translatedObj.labelDamages}}
          </p>
          <app-report-damages-table [damages]="purchasedItem.conditionReport?.damages"></app-report-damages-table>
        }
        @if (this.purchasedItem.titleAddress != null) {
          <div class="mail-title-section">
            <ng-content *ngTemplateOutlet="mailTitleToSectionPrint"></ng-content>
          </div>
        }
      }
    </div>
  </div>



  <ng-template #storageLocation>
    @if (!isMobile) {
      @if (!isAuthReport) {
        <app-datalist-item
          [identifier]="'Storage Location'"
          [label]="translatedObj.labelStorageLocation"
        ></app-datalist-item>
      }
      <div class="storageContent p-4">
        <div class="storageAddress pb-2">
          {{purchasedItem.storageLocation.name}}<br>
          {{purchasedItem.storageLocation.address1}} {{purchasedItem.storageLocation.address2}}<br>
          {{purchasedItem.storageLocation.city}}
          , {{purchasedItem.storageLocation.state}} {{purchasedItem.storageLocation.zip}}
          <br>
          </div>
          <div class="storageDetails">
            <app-datalist-item
              [identifier]="'Storage Contact'"
              [label]="translatedObj.labelStorageContact"
              value="{{showStorageContact}}"
            ></app-datalist-item>
            <app-datalist-item
              [identifier]="'Storage Phone'"
              [label]="translatedObj.labelStoragePhone"
              value="{{showStoragePhone}}"
            ></app-datalist-item>
            @if (!!purchasedItem.storageLocation.alternateContactName) {
              <app-datalist-item
                [identifier]="'Alternate Storage Contact'"
                [label]="translatedObj.labelAltStorageContact"
                value="{{purchasedItem.storageLocation.alternateContactName}}"
              ></app-datalist-item>
            }
            @if (!!purchasedItem.storageLocation.alternateContactPhone) {
              <app-datalist-item
                [identifier]="'Alternate Storage Phone'"
                [label]="translatedObj.labelAltStoragePhone"
                value="{{purchasedItem.storageLocation.alternateContactPhone | formatPhoneNumber}}"
              ></app-datalist-item>
            }
          </div>
        </div>
      } @else {
        <div class="storage-details additional-content" [style.padding-left]="isAuthReportMobile ? '1.625rem' : '0.625em'">
          <div class="mobile-content-row-1">
            <app-datalist-item
              class="mobile-label-spacing"
              [identifier]="'Storage Location'"
              [label]="translatedObj.labelStorageLocation"
            ></app-datalist-item>
            <span>{{purchasedItem.storageLocation.name}}</span><br>
            <span>{{purchasedItem.storageLocation.address1}} {{purchasedItem.storageLocation.address2}}</span><br>
            <span>{{purchasedItem.storageLocation.city}}, {{purchasedItem.storageLocation.state}}</span><br>
            <span>{{purchasedItem.storageLocation.zip}}</span><br>
          </div>
          <ng-container class="d-flex flex-row">
            <div class="mobile-content-row-2">
              @if (!!purchasedItem.storageLocation.alternateContactName) {
                <app-datalist-item
                  [identifier]="'Alternate Storage Contact'"
                  [label]="translatedObj.labelAltStorageContact"
                  value="{{purchasedItem.storageLocation.alternateContactName}}"
                ></app-datalist-item>
              }
              @if (!!purchasedItem.storageLocation.alternateContactPhone) {
                <app-datalist-item
                  [identifier]="'Alternate Storage Phone'"
                  [label]="translatedObj.labelAltStoragePhone"
                  value="{{purchasedItem.storageLocation.alternateContactPhone | formatPhoneNumber}}"
                ></app-datalist-item>
              }
            </div>
            <div class="mobile-content-row-2">
              <app-datalist-item
                [identifier]="'Storage Contact'"
                [label]="translatedObj.labelStorageContact"
                value="{{showStorageContact}}"
              ></app-datalist-item>
              <app-datalist-item
                [identifier]="'Storage Phone'"
                [label]="translatedObj.labelStoragePhone"
                value="{{showStoragePhone}}"
              ></app-datalist-item>
            </div>
          </ng-container>
        </div>
      }
    </ng-template>


    <ng-template #reportSideSelectRemit>
      <h4 class="fw-bold vehicle-summary-header">{{translatedObj.textVehicleSummary}}</h4>
      <div class="vehicle-summary-remit-content">
        <div class="vehicle-summary-remit-content-row-1">
          <app-datalist-item
            [identifier]="'Sale Date'"
            [label]="translatedObj.labelSaleDate"
            value="{{localizeDate(purchasedItem.saleDate)}}"
          ></app-datalist-item>
          <app-datalist-item
            [identifier]="'Sale Price'"
            [label]="translatedObj.labelSalePrice"
            value="{{formatCurrency(purchasedItem.salePrice, true)}}"
          ></app-datalist-item>
        </div>
        <div class="vehicle-summary-remit-content-row-2">
	      @if(!isSellSellerInvoiceReportVerbiageUpdateEnabled){
          <p class="fw-bold">{{translatedObj.textBuyerTaxes}}</p>
          <p>{{translatedObj.textBuyerTaxesSub}}</p>
	      }
          @if (taxSource.proceedsFederalTax) {
            <app-datalist-item
            [identifier]="'Vehicle Price GST/HST'"
            [label]="translatedObj.textPriceFederalTaxLabel"
            [value]="formatCurrency(taxSource.proceedsFederalTax, true)"
            ></app-datalist-item>
          }
          @if (taxSource.proceedsStateTax) {
            <app-datalist-item
            [identifier]="'Vehicle Price PST/RST/QST'"
            [label]="translatedObj.textPriceStateTaxLabel"
            [value]="formatCurrency(taxSource.proceedsStateTax, true)"
            ></app-datalist-item>
          }
        </div>
        <div class="vehicle-summary-remit-content-row-3">
          <p class="fw-bold">{{translatedObj.textSellerFeesAndTaxes}}</p>
          @for (fee of _sellFees | keyvalue: disableKeyValueSort; track fee) {
            <div>
              <app-datalist-item
                [identifier]="fee.key"
                [label]="translatedObj[fee.key]"
                value="{{formatCurrency(fee.value, true)}}"
              ></app-datalist-item>
            </div>
          }
        </div>
      </div>
      <div class="total-amount-remit">
        <app-datalist-item
          [identifier]="'Total Cost'"
          [label]="translatedObj.labelNetProceeds"
          value="{{formatCurrency(totalCost, true)}}"
        ></app-datalist-item>
      </div>
    </ng-template>


    <ng-template #mobilePreviewFooter>
      <div class="mobile-preview-footer d-block d-md-none">
        @if (showSellerComment) {
          <app-datalist-item
            [identifier]="'Seller Comments'"
            [label]="translatedObj.labelSellerComments"
            value="{{purchasedItem.sellerPaidComment}}"
          ></app-datalist-item>
        }
        @if (showTitleMessage) {
          <app-datalist-item
            [identifier]="'Title Message'"
            [label]="translatedObj.labelTitleMessage"
            value="{{purchasedItem.financeSource.titleMessage}}"
          ></app-datalist-item>
        }
        @if (showSellerDisclosure) {
          <app-datalist-item
            [identifier]="'Seller Disclosure'"
            [label]="translatedObj.labelSellerDisclosure"
            value="{{purchasedItem.seller.comment}}"
          ></app-datalist-item>
        }
        @if (showStoringLocation) {
          <app-datalist-item
            [identifier]="'Storing Location Message'"
            [label]="translatedObj.labelStorage"
            value="{{purchasedItem.storageLocation.pickupComment}}"
          ></app-datalist-item>
          @if (purchasedItem.storageLocation.additionalPickupComment) {
            <div class="additional-pickup-comment">
              {{purchasedItem.storageLocation.additionalPickupComment}}
            </div>
          }
        }
        <hr class="mobile-hr d-block d-md-none my-2">
        @if (isAuthReportMobile) {
          <div>
            @if (isShowBuyerDetails) {
              <div>
                @if (isBuyerDetailEnabled) {
                  <p #note></p>
                }
              </div>
            }
            <!-- Mobile  Authorization-->
            <div class="mobile-content-row-1">
              <ng-container>
                <p>
                  <app-datalist-item
                    class="mobile-label-spacing"
                    [identifier]="'Auction'"
                    [label]="translatedObj.labelAuction"
                  ></app-datalist-item>
                  <span>{{tenantName}}</span><br>
                  <span>{{platformAddress}}</span>
                </p>
              </ng-container>
            </div>
        @if(transportationCost) {
          <app-datalist-item
            [identifier]="'Transportation Fee'"
            [label]="translatedObj.labelTransportation">
            {{formatCurrency(transportationCost)}} {{translatedObj.labelFrom}} {{transportationName}} <br>
            <a href="mailto:{{transportationEmail}}">{{transportationEmail}}</a><br>
            <a href="tel:{{transportationNumber | formatPhoneNumber }}">{{transportationNumber | formatPhoneNumber}}</a>
          </app-datalist-item>
          <p><span class="transportation-warning">{{translatedObj.transportationNotice}}</span>
            {{translatedObj.transportationFeeNotice}}
          </p>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #mailTitleToSectionPrint>
 @if(!isSellSellerInvoiceReportVerbiageUpdateEnabled){
  <p class="fw-bold pb-2">{{translatedObj.labelTitleAddress}}</p>
  }@else{
  <p class="fw-bold pb-2">{{translatedObj.labelTitleAddressNew}}</p>
  }
  <p class="p-0 my-0">{{ titleAddressName }}</p>
  <p class="p-0 my-0">{{ titleAddressDetail }}</p>
  @if (titleAddressDetail2.length > 0) {
    <p class="p-0 my-0">{{ titleAddressDetail2 }}</p>
  }
  <p class="p-0 my-0">{{ titleAddressRegion }}</p>
</ng-template>
<ng-template #storageLocationContactMobile>
  <div class="storage-details additional-content" [style.padding-left]="isAuthReportMobile ? '1.625rem' : '0.625em'">
    <div class="mobile-content-row-1">
      <app-datalist-item
        class="mobile-label-spacing"
        [identifier]="'Storage Location'"
        [label]="translatedObj.labelStorageLocation"
      ></app-datalist-item>
      <span>{{purchasedItem.storageLocation.name}}</span><br>
      <span>{{purchasedItem.storageLocation.address1}} {{purchasedItem.storageLocation.address2}}</span><br>
      <span>{{purchasedItem.storageLocation.city}}, {{purchasedItem.storageLocation.state}}</span><br>
      <span>{{purchasedItem.storageLocation.zip}}</span><br>
    </div>
    <ng-container class="d-flex flex-row">
      <div class="mobile-content-row-2">
        @if (!!purchasedItem.storageLocation.alternateContactName) {
          <app-datalist-item
            [identifier]="'Alternate Storage Contact'"
            [label]="translatedObj.labelAltStorageContact"
            value="{{purchasedItem.storageLocation.alternateContactName}}"
          ></app-datalist-item>
        }
        @if (!!purchasedItem.storageLocation.alternateContactPhone) {
          <app-datalist-item
            [identifier]="'Alternate Storage Phone'"
            [label]="translatedObj.labelAltStoragePhone"
            value="{{purchasedItem.storageLocation.alternateContactPhone | formatPhoneNumber}}"
          ></app-datalist-item>
        }
      </div>
      <div class="mobile-content-row-2">
        <app-datalist-item
          [identifier]="'Storage Contact'"
          [label]="translatedObj.labelStorageContact"
          value="{{showStorageContact}}"
        ></app-datalist-item>
        <app-datalist-item
          [identifier]="'Storage Phone'"
          [label]="translatedObj.labelStoragePhone"
          value="{{showStoragePhone}}"
        ></app-datalist-item>
      </div>
    </ng-container>
  </div>
</ng-template>

  <ng-template #disclosures>
    @if (hasRedLight) {
      <app-condition-indicator variant="red" small="true"
        [conditionIndicatorTranslations]="conditionIndicatorTranslations"
      ></app-condition-indicator>
    }
    @if (hasYellowLight) {
      <app-vehicle-disclosures-indicator variant="yellow" small="true"
        [vehicleDisclosuresIndicatorTranslations]="conditionIndicatorTranslations"
        [vehicleDisclosuresCount]="purchasedItem.disclosures.yellowLights.length"
        [bulletedToolTipContentToolTipOverCount]="true"
        [vehicleDisclosuresList]="purchasedItem.disclosures.yellowLights"
      ></app-vehicle-disclosures-indicator>
    }
  </ng-template>
</ng-container>
